/**
 * Determine if currently inside an iframe.
 * This could be blocked in certain older browsers.
 * @returns {Boolean} True if `window.self` does not match `window.top`.
 */
export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

/**
 * Post message to parent window (when inside an iframe).
 * @param {Object|String} payload
 */
export const postMessage = (payload) => {
  let key = 'tgbGraphics:';
  key += typeof payload === 'object' ? JSON.stringify(payload) : payload;
  window.parent.postMessage(key, '*');
};
